import { Injectable } from '@angular/core';
import {URITemplates} from '../common/URITemplates';
import { HttpClient } from '@angular/common/http';
import { Observable,BehaviorSubject ,throwError} from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { organizationDTO } from 'src/app/models/providersDTO';
@Injectable({
  providedIn: 'root'

  
})
export class CommonService {
  objURITemplates:URITemplates =new URITemplates();
  constructor(private http: HttpClient) { }


  public getConfig() {
    let bases = document.getElementsByTagName('base');
    let baseHref = null;
    if (bases.length > 0) {
      baseHref = bases[0].href;
    }
    return this.http.get(baseHref + "assets/app/config.json?"+new Date().toLocaleDateString()).toPromise();
  }

  public getURL(path) {
    var APIHostAddress = localStorage.getItem('APIHostAddress');
    var FullURL = APIHostAddress + path;
    return FullURL;
  }

  public getOrganizationDetails(): any {
    var APIHostAddress = localStorage.getItem('APIHostAddress');
    var FullURL = APIHostAddress + this.objURITemplates.getOrganizationDetails;
      return this.http.get(FullURL+ '?orgUnit='+1).toPromise().then((data:organizationDTO) => {
        return data;
      }).catch((err)=>{
        console.log('getOrganizationDetails() error in interceptor' + err);
        return null;
    });
  }

  public getSearchValue(inputdata): string {
    try {
      //debugger;
      let lettersRegEx =new RegExp('^[a-zA-Z.,/; #&]+$');
      let lettersNumbersRegEx =new RegExp('^[a-zA-Z0-9.,/; #&]+$');
      let numbersRegEx =new RegExp('^[0-9- ]+$');
      if (lettersRegEx.test(inputdata) || lettersNumbersRegEx.test(inputdata))
      {
        
          if (numbersRegEx.test(inputdata))
          {
            //only numbers
              return inputdata;
              
          }
          else
          {
            //only letters
            return inputdata;
          }
      }
      else
      {
          //removed the special characters
          let output=  inputdata.replace(/[^0-9]+/ig,"");
          if(output!="" || output!=undefined)
          {
              //only numbers returned after removing the all special characters
              return output;
          }
          else
          {
            return inputdata;
          }
      }
    }
    catch (err) {

    }
    return undefined;
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // client-side error
        errorMessage = `Error: ${error.error.message}`;
    } else {
        // server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
}
}
